import styled from 'styled-components';
import SvgSpinner from '../../others/svg_dist/Spinner';

export const Wrapper = styled.div`
	width: 100%;
	height: calc(100vh - 150px);
	min-height: 800px;
	background-color: #24376c;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	@media screen and (max-width: 1200px) {
		right: 50%;
		transform: translateX(50%);
	}
`;

export const ContentContainer = styled.div`
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	z-index: 9;
	transform: translateY(50%);
	@media screen and (max-width: 1200px) {
		margin-right: unset;
	}
	@media screen and (max-width: 500px) {
		transform: translateY(30%);
	}
`;

export const HeadingsContainer = styled.div`
	display: flex;
	flex-flow: column nowrap;
	width: 95%;
	margin: auto;
	text-align: center;
	@media screen and (max-width: 1200px) {
		align-items: center;
	}
`;

export const HeadingFont = styled.p`
	margin: 0;
	line-height: 1.2;
	font-size: 28px;
	color: #fff;
	font-family: Montserrant-Black;
	span {
		color: #eff3a9;
	}
`;

export const GenericFont = styled.p`
	margin: 0;
	line-height: 1.2;
	font-size: 16px;
	color: #cccccc;
	white-space: nowrap;
	a {
		color: inherit;
		margin-left: 6px;
	}
	@media screen and (max-width: 600px) {
		text-align: center;
	}
`;

export const InfoContentContainer = styled.div`
	padding: 30px 20px;
	border-radius: 0 22px 22px 0;
	width: 100%;
	background-color: #24376c;
	@media screen and (max-width: 600px) {
		border-radius: 0 0 22px 22px;
	}
`;

export const PaywallContainer = styled.div`
	width: 95%;
	margin: auto;
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	@media screen and (max-width: 800px) {
		flex-flow: column nowrap;
		align-items: center;
	}
`;

export const PaywallButton = styled.button`
	all: unset;
	cursor: pointer;
	width: 300px;
	border: 2px solid #eff3a9;
	border-radius: 100px;
	padding: 14px 10px;
	color: #fff;
	text-align: center;
	font-weight: 600;
	font-size: 16px;
	@media screen and (max-width: 800px) {
		margin: 0;
		margin-top: 30px;
	}
`;

export const FooterWrapper = styled.div`
	height: 150px;
	width: 100%;
	background-image: linear-gradient(
		135deg,
		#24376c 25%,
		#293f7b 25%,
		#293f7b 50%,
		#24376c 50%,
		#24376c 75%,
		#293f7b 75%,
		#293f7b 100%
	);
	background-size: 15px 15px;
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	@media screen and (max-width: 1200px) {
		height: 175px;
	}
	@media screen and (max-width: 800px) {
		height: 200px;
	}
	@media screen and (max-width: 600px) {
		height: 225px;
	}
	@media screen and (max-width: 450px) {
		height: 250px;
	}
`;

export const FooterGenericFont = styled.p`
	margin: 0;
	line-height: 1.4;
	font-size: 14px;
	color: #cccccc;
	text-align: center;
	padding: 0 4px;
	span {
		font-weight: 600;
		color: #fff;
	}
	a {
		text-decoration: none;
	}
`;

export const StyledSvgSpinner = styled(SvgSpinner)`
	margin: 0 auto;
	margin-top: 40px;
	width: 70px;
	height: 70px;
	fill: #fff;
	animation-name: Spin;
	animation-iteration-count: infinite;
	animation-duration: 1s;
	@keyframes Spin {
		0% {
			rotate: 0deg;
		}
		100% {
			rotate: 360deg;
		}
	}
`;
